const mandrill = require('mandrill-api/mandrill')
const mandrill_client = new mandrill.Mandrill('XXXXXXX')
const response = require('palmettoflow-event').response
const responseError = require('palmettoflow-event').responseError


module.exports = function() {
	return function(ee) {

		ee.on('/email/send', function(event) {
			// var toEmail = getToEmail(event.object.reason);
			var toEmail = "";


		})
	}
}



// WEBPACK FOOTER //
// ./services/emailSvc/index.js